export default __webpack_public_path__ + "static/media/logo-real.7835853f.png";